<div class="master-modal" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <!-- Modal-Header -->
      <div class="modal-header">
        <h4 class="modal-title">{{ isEditMode ? 'Edit NewsFeed' : 'Add NewsFeed' }} </h4>
        <div _ngcontent-serverapp-c439="" class="modal_close_btn"><span _ngcontent-serverapp-c439="" class="modal-close"><i _ngcontent-serverapp-c439="" class="material-icons"
              (click)="cancel()">close</i></span>
        </div>
      </div>
      <!-- Modal content-->
      <form class="form-section" [formGroup]="newsfeedForm">
        <perfect-scrollbar class="modal-body-scrollbar">
          <div mat-dialog-content>
            <div class="modal-body approve-popup">
              <div class="custom-form-group">
                <div class="custom-form-control">
                  <label class="custom-label" for="" style="display: flex;">Description <span class="star">*</span></label>
                  <mat-form-field appearance="outline" class="w-100">
                    <textarea rows="5" cols="5" maxlength="6000" matInput formControlName="description" placeholder="Enter your Description"></textarea>
                    <mat-error *ngIf="newsfeedForm.get('description')?.invalid">
                      {{ getErrorMessage('description') }}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="custom-form-control">
                <label class="custom-label">Select Category <span class="star">*</span></label>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-select formControlName="category_type" placeholder="Select Category">
                    <mat-option *ngFor="let category of categoriesFilter" [value]="category.id">
                      {{ category.category_name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="newsfeedForm.get('category')?.invalid">
                    {{ getErrorMessage('category') }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="custom-form-group">
                <label class="custom-label">Upload File</label>
                <div class="custom-form-control">
                  <div class="master_uploader">

                    <div class="img_uploader"
                      style="position: relative; display: inline-block; padding: 10px; border: 2px dashed #ccc; border-radius: 8px; text-align: center; cursor: pointer; width: 100px; height: 100px; background-color: #f9f9f9;">
                      <input type="file" class="file_input" accept="image/*,video/*,audio/mpeg,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt" multiple (change)="onSelectBasicBannerImage(fileInput.files, fileInput)" #fileInput
                        (click)="$event.stopPropagation()" formControlName="post_image" style="position: absolute; width: 100%; height: 100%; opacity: 0; cursor: pointer;">
                      <span style="font-size: 14px; color: #888;"><mat-icon style="width: 40px; height: 40px; font-size: 40px;margin-top: 17px;">attach_file</mat-icon>
                      </span>
                    </div>
                    <div class="unique-upload-container" style="margin-top: 10px;">
                      <ul *ngIf="uploadedFiles.length" class="unique-upload-list">
                        <li *ngFor="let file of uploadedFiles" class="unique-upload-item" style="cursor: pointer;">
                          <ng-container *ngIf="file.type.includes('image')">
                            <img [src]="file.url" alt="Uploaded Image" class="unique-upload-image" (click)="feedImageView(file) ">
                          </ng-container>
                          <ng-container *ngIf="file.type.includes('video')">
                            <video controls class="unique-upload-video" (click)="feedVideoView(file)">
                              <source [src]="file.url" type="video/mp4">
                              Your browser does not support the video tag.
                            </video>
                          </ng-container>
                          <ng-container *ngIf="isDocument(file.type)">
                            <!-- <a [href]="file.url" target="_blank" class="unique-upload-pdf">View PDF</a> -->
                            <a href="javascript:void(0);" (click)="feeddocumentView(file)" class="unique-upload-pdf">
                              <!-- View Document -->
                              <img src="../../../../../assets/images/file_icons/pdf.svg" *ngIf="file?.name?.includes('.pdf')">
                              <img src="../../../../../assets/images/file_icons/doc.svg" *ngIf="file?.name?.includes('.doc')">
                              <img src="../../../../../assets/images/file_icons/PPT.svg" *ngIf="file?.name?.includes('.ppt')">
                              <img src="../../../../../assets/images/file_icons/xls.svg" *ngIf="file?.name?.includes('.xls')">
                              <img src="../../../../../assets/images/file_icons/TXT.svg" *ngIf="file?.name?.includes('.txt')">
                              <img src="../../../../../assets/images/file_icons/CSV.svg" *ngIf="file?.name?.includes('.csv')">
                            </a>
                          
                          </ng-container>
                          <div class="unique-upload-close" (click)="removeFile(file)">
                            <img src="../../../../../assets/images/icons/close.svg" alt="Remove" class="unique-upload-close-icon">
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="custom-form-control">
                <label class="custom-label" for="video_url">Enter Video Link</label>
                <mat-form-field appearance="outline">
                  <input matInput type="url" formControlName="video_url" placeholder="Enter Video URL" />
                  <mat-error *ngIf="newsfeedForm.get('video_url')?.invalid">
                    {{ getErrorMessage('video_url') }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="custom-form-control">
                <label class="custom-label" for="">Enter Website Link</label>
                <mat-form-field appearance="outline">
                  <input matInput type="url" formControlName="web_url" placeholder="Enter Website URL" />
                  <mat-error *ngIf="newsfeedForm.get('webUrl')?.invalid">
                    {{ getErrorMessage('web_url') }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
        </perfect-scrollbar>
        <div class="modal-footer">
          <button type="button" mat-button (click)="cancel()" class="">
            <span> Cancel </span>
          </button>
          <button type="submit" type="button" mat-button (click)="submitData()" class="global-btn delete-btn"
            style="background-image: linear-gradient(to right, #e40000, #fca300) !important;">
            <span>{{ isEditMode ? 'Update' : 'Add' }}</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
